// Story 213 v2 — sensitive marks (C1, C2 `SensitiveMarkDto`, C3).

// C3 literals with a variable part; their i18n keys carry the gap instead (H-v2-3/13).
const NOT_FOUND = /^Sensitive item not found: (\S+) (.+)$/
const UNKNOWN_TYPE = /^Unknown sensitive type: (.+)$/

// The text to show for a rejected marking, translated with the real values in the gaps (C7.1, E11).
export const sensitiveMarkErrorText = (message, t_) => {
  const notFound = NOT_FOUND.exec(message)
  if (notFound) {
    return t_('Sensitive item not found: <type> <key>').replace('<type>', notFound[1]).replace('<key>', notFound[2])
  }
  const unknownType = UNKNOWN_TYPE.exec(message)
  if (unknownType) {
    return t_('Unknown sensitive type: <value>').replace('<value>', unknownType[1])
  }
  return t_(message)
}
